<template>
    <div v-if="config">
        <v-text-field v-model="config.mandate" label="Mandate" />
    </div>
</template>

<script>
export default {
    props: ["config"]
};
</script>